import { limpar } from "./utils";

export const BUSCA_PUBLICA_MIN_CARACTERES = 3;

export const BUSCA_PUBLICA_HELPER =
  "Mínimo de 3 caracteres para nome, ou CPF/CNPJ completo.";

/**
 * Alinha com InterpretarBuscaPublica + mínimo de 3 caracteres no PublicacaoService.
 * Termo vazio lista tudo; documento completo (11/14 dígitos) ou nome ≥ 3 chars são válidos.
 */
export function isBuscaPublicaElegivel(busca) {
  if (busca == null) return true;

  const termo = String(busca).trim();
  if (!termo) return true;

  const digitos = limpar(termo);
  const semDigitos = termo.replace(/\d/g, "").trim();
  const apenasFormatacaoDocumento =
    semDigitos.length === 0 ||
    [...semDigitos].every((caractere) => ".-/ ".includes(caractere));

  if (
    (digitos.length === 11 || digitos.length === 14) &&
    apenasFormatacaoDocumento
  ) {
    return true;
  }

  return termo.length >= BUSCA_PUBLICA_MIN_CARACTERES;
}
